"use client";

import { useEffect, useState } from "react";

type TocItem = { id: string; label: string };

export function DocsTOC({ items }: { items: TocItem[] }) {
  const [active, setActive] = useState<string>(items[0]?.id ?? "");

  useEffect(() => {
    const headings = items
      .map((i) => document.getElementById(i.id))
      .filter((el): el is HTMLElement => el !== null);
    if (headings.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setActive(visible[0].target.id);
      },
      { rootMargin: "-88px 0px -70% 0px", threshold: 0 },
    );
    headings.forEach((h) => observer.observe(h));
    return () => observer.disconnect();
  }, [items]);

  if (items.length === 0) return null;

  return (
    <nav aria-label="On this page" className="hidden xl:block">
      <div className="sticky top-24">
        <p className="text-[11px] font-medium uppercase tracking-[0.14em] text-fg-muted">
          On this page
        </p>
        <ul className="mt-4 space-y-2 border-l border-edge">
          {items.map((t) => (
            <li key={t.id}>
              <a
                href={`#${t.id}`}
                className={`-ml-px block border-l pl-4 text-[13px] transition-colors duration-200 ${
                  active === t.id
                    ? "border-accent text-fg"
                    : "border-transparent text-fg-muted hover:border-edge-strong hover:text-fg"
                }`}
              >
                {t.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
